
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RegistrationService } from '@app/features/registration/services/registration.service';
import { Clinic } from '@app/shared/interfaces/clinic.interface';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-clinic-search-dropdown',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    NgxMatSelectSearchModule
],
  templateUrl: './clinic-search-dropdown.component.html'
})
export class ClinicSearchDropdownComponent implements OnInit, OnDestroy {
  @Input() required = false;
  @Input() dropdownLabel!: string;
  @Input() dropdownSelectionFormControl!: FormControl;
  @Input() showError = true;

  onDestroy = new Subject<void>();
  dropdownOptions: Clinic[] = [];
  filteredDropdownOptions: Clinic[] = [];
  searchBarFormControl: FormControl = new FormControl();
  noOptionsText = 'No options found';

  constructor(
    private registrationService: RegistrationService
  ) {}

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit(): void {
    this.fetchClinicList();
  }

  fetchClinicList() {
    this.registrationService.getClinicList()
      .pipe(takeUntil(this.onDestroy))
      .subscribe((list: Clinic[]) => {
        this.dropdownOptions = list;
        this.filteredDropdownOptions = [...this.dropdownOptions];
        this.subscribeToSearchControlValueChanges();
      });
  }

  filterClinics() {
    const search = (this.searchBarFormControl.value ?? '').toString().trim().toLowerCase();
    if (!search) {
      this.filteredDropdownOptions = [...this.dropdownOptions];
    } else {
      this.filteredDropdownOptions =
        this.dropdownOptions.filter(option => (option.name ?? '').toLowerCase().includes(search));
    }
  }

  subscribeToSearchControlValueChanges() {
    this.searchBarFormControl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.filterClinics();
      });
  }

  onSelectionChange(): void {
    if (this.dropdownSelectionFormControl.disabled) {
      return;
    }
    this.dropdownSelectionFormControl.markAsDirty();
    this.dropdownSelectionFormControl.markAsTouched();
  }
}
